import { SpeciesSearchScreen } from '@screens/SpeciesSearch/SpeciesSearchScreen';

export default function ReportCreationSpeciesScreen(): React.ReactNode {
  return <SpeciesSearchScreen />;
}
